/// <amd-module name="VSS/Features/MarkdownItKatex/MarkdownItKatexService" />
import * as MarkdownIt from "markdown-it";
import { IMarkdownItKatexService } from "VSS/Features/MarkdownItKatex/IMarkdownItKatexService";
import { MarkdownItKatex } from "VSS/Features/MarkdownItKatex/MarkdownItKatex";
import { Services, VssService } from "VSS/Platform/Context";

export class MarkdownItKatexPluginService extends VssService implements IMarkdownItKatexService {
    public register(renderer: MarkdownIt.MarkdownIt): void {
        renderer.use((md: MarkdownIt.MarkdownIt) => new MarkdownItKatex(md));
    }
}

Services.add("markdown-it-katex-service", { serviceFactory: MarkdownItKatexPluginService });
